<template>
  <div class="page page-news">
    <div class="page__wrap" data-animate="page-wrap" v-if="news">
      <header class="row-1 p-top-5" ref="text">
        <NavigationBackLink
          class="m-bot-5"
          data-animate="header-content"
          :link="{
            title: $t('pages.news.backLinkNews'),
            route: {
              name: 'news',
            },
          }"
        />

        <!-- TODO: Uso le classi del blocchetto. Non è stupnda come cosa ma evita la creazione di un template per la pulizia. Se vogliamo possiamo migliorare-->
        <div
          class="page-news-list-block__content__preheader"
          data-animate="header-content"
        >
          <p class="text-s">{{ date }}</p>
          <p
            class="text-uppercase text-xs page-news-list-block__content__filters"
          >
            <strong v-for="(filter, index) in news.newsType" :key="index">{{
              $t(`filters.${filter}`)
            }}</strong>
          </p>
        </div>

        <!-- Titolo  -->
        <h1 data-animate="header-title" class="title-m">
          {{ news.title }}
        </h1>

        <!-- Picture -->
        <div v-if="news.cover?.[0]" class="m-top-4" data-animate="header-image">
          <WidgetPicture
            :image="{
              custom: news.cover?.[0],
            }"
            :alt="news.cover?.[0]?.title"
            :lazyLoad="true"
          />
        </div>
      </header>
      <!-- Editorial -->
      <div class="p-bot-3" data-animate="page-content">
        <LazyEditorialList
          v-if="news?.editorialContent?.length"
          :content="news.editorialContent"
        />
      </div>

      <div v-if="latest.length" class="row-1 p-bot-3">
        <div
          class="page-news__latest p-top-5 flex --justify-space-between --align-center"
        >
          <h2 class="title-m m-right-16px flex-1" v-anim-reveal-text>
            {{ $t('pages.news.otherTitle') }}
          </h2>

          <LazyWidgetLinkMainUnderline
            :link="{ key: 'view-all', route: { name: 'news' } }"
          />
        </div>

        <!-- List -->
        <LazyPagesNewsList
          class="m-top-4"
          :news="latest"
          v-anim-parallax-element="{
            target: 'picture',
            offset: 10,
          }"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useCraftStore } from '@/store/craft.js'

import queries from '@/graphql/craft/queries/index.js'

import {
  onBeforeEnter,
  onEnter,
  onLeave,
} from '~/assets/js/page-transitions/editorial.js'

definePageMeta({
  layout: 'default',
  pageTransition: {
    onBeforeEnter: (el) => {
      onBeforeEnter(el)
    },
    onEnter: async (el, done) => {
      const tl = onEnter(el, done)
      await tl.delay(0.5).play()
      done()
    },
    onLeave: async (el, done) => {
      const tl = onLeave(el)
      await tl.play()
      window.lenis.scrollTo(0, { immediate: true })
      done()
    },
  },
})

// Fetch Craft
const { configuration } = useCraftStore()
const route = useRoute()

const { locale } = useI18n()

const query = queries.news.getNews
const variables = computed(() => ({
  site: configuration.site,
  marketId: configuration.marketId,
  newsSlug: route.params.slug,
}))
const { data } = await useGraphql(query, variables)

if (!data.value?.newsEntries?.[0]) {
  throw createError({ statusCode: 404 })
}

const news = computed(() => data.value?.newsEntries?.[0])
const latest = computed(() =>
  data.value?.latest.filter((article) => article.slug !== route.params.slug)
)

const date = computed(() => {
  return new Intl.DateTimeFormat(locale.value).format(
    new Date(data.value?.newsEntries?.[0]?.postDate)
  )
})

const seo = computed(() => data.value?.newsEntries?.[0]?.seo || {})
const localeParams = computed(
  () => data.value?.newsEntries?.[0]?.localized || {}
)

// Seo
useSeo({
  ...seo.value,
  localeParams: useHelpers().generateSeoLocaleParams(localeParams, 'slug'),
  market: news?.value?.market,
})
</script>
